/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { PlatformError } from '../Errors';
import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/**
 * Code unique to REACH
 */
export interface TeamviewerInterface {
    /**
     * Retrieve the Device ID used by Teamviewer to connect to the player.
     *
     * @throws {@link PlatformError}
     * if Teamviewer wasn't installed by REACH
     *
     * @throws {@link PlatformError}
     * if NamedValueCache is not implemented
     */
    getRemoteSupportDeviceId(): Promise<string>;
}

export function supportsTeamviewer(platform: unknown): platform is TeamviewerInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PlatformMessage.RemoteSupportDeviceIdGet);
    }
    return platform instanceof Object && 'getRemoteSupportDeviceId' in platform;
}
